import React from 'react';
import classNames from 'classnames';
import { DiscordFillBrand } from 'lib/lucky-x-icons-2';

interface IHelpProps {}

const Help: React.FC<IHelpProps> = ({}) => {
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-xl border border-neutral-600 px-5 py-6  lg:flex-row">
      <div className="whitespace-pre-line text-center text-base font-medium text-white">
        Need help? Please join our Discord and submit a ticket
      </div>
      <div
        className="flex h-10  cursor-pointer items-center justify-center gap-2 rounded-3xl bg-[#5865F2] px-4 text-sm font-medium text-white hover:bg-opacity-90"
        onClick={() => {
          open('https://discord.gg/Gykdc8PNwv');
        }}
      >
        <div>Join Discord</div>
        <DiscordFillBrand size={24} />
      </div>
    </div>
  );
};

export default Help;
